exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-chips .md-chip-input-container {\n  width: 50%;\n  min-width: 240px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/olr-mainfe-announcement/styles/index.scss
 ** module id = 224
 ** module chunks = 1
 **/